import React, { useState, useEffect } from 'react';
import CloseButton from '../../../../sharecomponents/CloseButton';

const SelectorFiltrosCampo = (p) => {
    const [paginador, setpaginador] = useState(p.paginador);
    const close = p.close ?? (() => { });
    const filtros = p.filtros ?? { camas: [], colores: [], flores: [], orden: [], variedades: [], ranchos: [], 'semana trasplante': [], 'semana siembra': [], 'semana corte': [], tuneles: [], valvulas: [], usuarios: [], estado: [] };
    const fields = ['flor', 'variedad', 'color', 'order', 'rancho', 'semana_trasplante', 'semana_siembra', 'semana_cosecha', 'tunel', 'valvula', 'usuario', 'estado'];
    const keysFiltros = ['flores', 'variedades', 'colores', 'orden', 'ranchos', 'semana trasplante', 'semana siembra', 'semana corte', 'tuneles', 'valvulas', 'usuarios', 'estado'];
    var counter = 0;
    const keyGen = () => { counter++; return counter + "filtros"; }
    const aplicarFiltros = () => close({ ...paginador, ['page']: 1 });
    const limpiarFiltros = () => {
        close({
            "page": 1,
            "pages": 0,
            "total": 0,
            "limit": 100
        })
    }

    const change = (e) => setpaginador({ ...paginador, [e.target.name]: e.target.value });


    return (
        <div className='vh-100 vw-100 overflow fixed blur-xl p-2 bg-white4' style={{ top: 0, left: 0, zIndex: 555 }}>

            <CloseButton close={() => close(false)} />
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='bw-900 round-m shadow-multi p-2 bg-white'>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        <div className='w-100 text-center m-0 p-0 text-300 h3'>GALERIA DE FILTROS</div>
                        <div className='w-100 text-s m-0 p-0 text-center mb-4'>Seleccione todos los filtros que desea aplicar y después pulse el botón actualizar</div>
                        {keysFiltros.map((k, i) =>
                            <div key={keyGen()} className='form-group m-1 mt-3 bw-250'>
                                <div className='w-100 text-satart ps-2 text-s text-bold'>{k.toUpperCase()}</div>
                                <select className={'form-control border shadow-sm  ' + (paginador[fields[i]] ? " border-info" : "")} value={paginador[fields[i]] ?? ""} name={fields[i]} onChange={change}>
                                    <option value='' >TODO</option>
                                    {filtros[k].map((fil, j) => <option key={keyGen()} value={fil.value}>{fil.nombre}</option>)}
                                </select>

                            </div>


                        )}
                        {['sombra', 'electrificada', 'micro', 'hoops'].map((k, i) =>
                            <div className='form-group m-1 mt-3 bw-250' key={keyGen()}>
                                <div className='w-100 text-satart ps-2 text-s text-bold'>{k.toUpperCase()}</div>
                                <select className={'form-control border shadow-sm ' + (paginador[k] ? " border-info" : "")} name={k} value={paginador[k]} onChange={change}>
                                    <option value='' >TODO</option>
                                    <option value='SI' >SI</option>
                                    <option value='NO' >NO</option>
                                </select>
                            </div>
                        )}

                        <div className='form-group m-1 mt-3 bw-250'>
                            <div className='w-100 text-satart ps-2 text-s text-bold'>TIPO DE AGUA</div>
                            <select className={'form-control border shadow-sm ' + (paginador.tipo_agua ? " border-info" : "")} name='tipo_agua' value={paginador.tipo_agua ?? ""} onChange={change}>
                                <option value='' >TODO</option>
                                <option value='SIN RO' >SIN RO</option>
                                <option value='RO' >CON RO</option>
                            </select>
                        </div>
                        <div className='w-100 text-center mt-4 mb-1'>
                            <button className='btn btn-sm btn-light border border-danger round-xxl border-3 shadow bw-200' onClick={limpiarFiltros} >DESELECCIONAR Y APLICAR</button>
                        </div>
                        <div className='w-100 text-center mt-2 mb-4'>
                            <button className='btn btn-warning shadow bw-400 text-bold' onClick={aplicarFiltros} >APLICAR FILTROS</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default SelectorFiltrosCampo;